import { Button, ButtonVariant } from "@merge-api/merge-javascript-shared";
import { ArrowLeft, X } from "lucide-react";

type Props = {
  onBack?: () => void;
  onExit: () => void;
};

const CardHeader = ({ onBack, onExit }: Props) => {
  return (
    <div className="flex justify-between items-center pt-3 px-3 pb-0">
      {/* Back */}
      {onBack ? (
        <Button size="sm" variant={ButtonVariant.TextBlack} onClick={onBack}>
          <ArrowLeft className="text-gray-40 -mx-1" size={24} />
        </Button>
      ) : (
        // placeholder div for flex
        <div className="h-[30px]" />
      )}

      {/* X */}
      <Button size="sm" variant={ButtonVariant.IconShadowHidden} onClick={onExit}>
        <X className="text-black" size={24} />
      </Button>
    </div>
  );
};

export default CardHeader;
